import axios from 'axios'
import router from '@/router/index';
import store from '@/stores/index';
import eventBus from '@/services/eventBus';
import lang from '@/lang/lang'
import {API_SAVE_ORDER_CONSTRUCTION_SITE_ID_LIST, API_DELETE_CONSTRUCTION_SITE, API_UPDATE_PROJECT, API_SAVE_CONSTRUCTION_SITE, API_ADD_CONSTRUCTION_USER, API_LOGIN, API_LOGIN_FROM_APP, API_LOGIN_FROM_APP_FOR_USER_INFO} from '@/configs/api';
  
window.axios = axios;
const DEFAULT_SHOW_LOADING = true
const AJAX_LOADING_TIME = 500 // 500ms
let showLoadingCount = 0
let ajaxLoadingStartTime = 0

function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function hiddenAjaxLoading (config) {
  if (showLoadingCount > 0 && (typeof config.showLoading === 'undefined' || config.showLoading === true)) {
    showLoadingCount -= 1;
  }
  if (showLoadingCount === 0) {
    hideAjaxLoading()
  }
}

function showAjaxLoading () {
  ajaxLoadingStartTime = Date.now()
  // Show AJAX Loading
  eventBus.$emit('showAjaxLoading', true)
}

async function hideAjaxLoading () {
  let time = Date.now() - ajaxLoadingStartTime
  if (time < AJAX_LOADING_TIME) {
    await sleep(AJAX_LOADING_TIME - time)
  }
  eventBus.$emit('showAjaxLoading', false)
}

axios.interceptors.request.use(async function (config) {
  if (!navigator.onLine) {
    eventBus.$emit('apiError', {});
    return;
  }
  if (typeof config.showLoading === 'undefined' || config.showLoading === true) {
    showLoadingCount += 1;
  }

  if (showLoadingCount > 0) {
    showAjaxLoading()
  } else {
    hideAjaxLoading()
  }

  return config
}, function (err) {
  return Promise.reject(err)
});

axios.interceptors.response.use(function (response) {
  hiddenAjaxLoading(response.config);
  if (!navigator.onLine) {
    eventBus.$emit('apiError', {});
    return;
  }

  const arrayComponentsIgnore = [ // components name
    'FullInfoRegister'
  ];
  if (arrayComponentsIgnore.includes(router.currentRoute.name)) return response;

  // const arrayErrorCodeToHandle = [
  //   {code: 401, onAlert: () => router.push({name: 'Login'})},
  //   {code: 400, onAlert: () => {}},
  //   {code: 402, onAlert: () => {}},
  //   {code: 403, onAlert: () => {}},
  //   {code: 500, onAlert: () => {}},
  // ];
  // let currentError = arrayErrorCodeToHandle.find(item => item.code === response.data.code);
  // if (currentError) {
  //   eventBus.$emit('apiError', response, currentError);
  // }

  const componentsIgnoreAlert = [
    {name: 'ProjectList', code: 402, api: API_UPDATE_PROJECT},
    {name: 'UpdateConstructionInfo', code: 402, api: API_UPDATE_PROJECT},
    {name: 'ReportDetail', code: 405, api: API_SAVE_ORDER_CONSTRUCTION_SITE_ID_LIST},
    {name: 'ReportDetail', code: 406, api: API_DELETE_CONSTRUCTION_SITE},
    {name: 'EditConstructionSite', code: 406, api: API_SAVE_CONSTRUCTION_SITE},
    {name: 'AddStampConstructionSite', code: 406, api: API_SAVE_CONSTRUCTION_SITE},
    {name: 'AcceptInvite', code: 406, api: API_ADD_CONSTRUCTION_USER},
    {name: 'Login', code: 406, api: API_LOGIN},
    {name: 'Account', code: 406, api: API_LOGIN_FROM_APP_FOR_USER_INFO},
    {name: 'AddConstructionUserFromApp', code: 406, api: API_LOGIN_FROM_APP},
    {name: 'CreateReportPositionFromApp', code: 406, api: API_LOGIN_FROM_APP},
    {name: 'ApplicationDetails', code: 406, api: API_LOGIN_FROM_APP_FOR_USER_INFO},
  ]
  let resCode = response.data.code
  if (resCode && resCode !== 200) {
    let componentIgnoreIndex = componentsIgnoreAlert.findIndex(component =>
      component.name === router.currentRoute.name && resCode === component.code &&
      component.api === response.config.url)
    
    if (componentIgnoreIndex === -1) {
      eventBus.$emit('apiError', response);
      if (resCode === 401) {
        store.dispatch('logout')
        if (router.currentRoute.name !== 'Login') {
          router.push({name: 'Login'})
        }
      }
    }
  }

  return response;
}, function (error) {
  let config = error ? error.config : {};
  hiddenAjaxLoading(config);
  if (!error.response) {
    // do not http error, it is js error
    throw error
  }

  // retry AJAX
  config.currentRetry = 'currentRetry' in config ? config.currentRetry : 0;
  if (config.retry && config.retry > 0 && config.currentRetry < config.retry) {
    config.currentRetry++;
    return window.axios.request(config);
  }

  if (error.response && error.response.status && error.response.status !== 200) {
    eventBus.$emit('apiError', {
      data: {
        error_message: lang.t('common.api_error', {code: error.response.status})
      }
    });
  }

  return Promise.reject(error)
});

axios.defaults.headers.common['Accept'] = 'application/json,api-version=0.1';
// axios.defaults.headers.common['contentType'] = 'application/json';
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Cache-control'] = 'no-store';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = 0;
axios.defaults.headers.common['Timezone'] = new Date().getTimezoneOffset();
// axios.defaults.timeout = 1000;
// window.axios.defaults.headers.common['Accept-Encoding'] = 'gzip/json,deflate';
// window.axios.defaults.headers.common['Connection'] = 'keep-alive';

export default {
  request (method, url, params, data, headers = {}, config = {retry: 0, showLoading: DEFAULT_SHOW_LOADING}) {
    return axios.request({...config, url, params, data, method: method.toLowerCase(), headers});
  },

  get (url, params, config = {retry: 0, showLoading: DEFAULT_SHOW_LOADING}) {
    return this.request('get', url, params, {}, {}, config)
  },

  post (url, data, headers = {}, config = {retry: 0, showLoading: DEFAULT_SHOW_LOADING}) {
    return this.request('post', url, {}, data, headers, config)
  },

  put (url, data, config = {retry: 0, showLoading: DEFAULT_SHOW_LOADING}, headers) {
    return this.request('put', url, {}, data, {...headers}, config)
  },

  delete (url, data = {}, config = {retry: 0, showLoading: DEFAULT_SHOW_LOADING}) {
    return this.request('delete', url, {}, data, {}, config)
  },
  showAjaxLoading: () => {
    showLoadingCount += 1;
    showAjaxLoading()
  },
  hideAjaxLoading: () => {
    showLoadingCount = showLoadingCount > 0 ? showLoadingCount - 1 : 0
    if (showLoadingCount === 0) {
      hideAjaxLoading()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js